import { registerDestructor } from '@ember/destroyable';
import { task, timeout } from 'ember-concurrency';
import { tracked } from '@glimmer/tracking';
import { next } from '@ember/runloop';
import Feed, { LIVE_STREAM_PAUSE_GRACE_MS } from './feed';
export default class FallbackFeed extends Feed {
  kind = 'fallback'

  @tracked infoObject;

  constructor(infoObject, options = {}) {
    super(infoObject, options);
    this.infoObject = infoObject;
    this.startTask.perform();
    registerDestructor(this, this.teardown.bind(this));
  }

  get isLive() {
    return true; // broadcast feed = live feed
  }

  get imageUrl() {
    return this.imageSource?.medium_square?.url
  }

  get url() {
    return this.infoObject?.url;
  }

  get canPlay() {
    return !!this.url
  }

  // A bare stream URL has no end. Same reasoning as BroadcastFeed.
  loadDuration() {
    return Infinity;
  }

  loadStreamPauseGraceMs() {
    return LIVE_STREAM_PAUSE_GRACE_MS;
  }

  startTask = task(async () => {
    if (this.settings.debug) {
      console.log(`built fallback feed with options ${this.infoObject}, starting monitors`);
    }

    // A fallback feed is a bare stream URL with no now-playing model behind it,
    // so there are no attributes to hydrate and no monitor loop to run.
    next(() => (this.isLoaded = true));
  });

  playTask = task({ restartable: true, maxConcurrency: 1 }, async () => {
    // `loadedSound` is an always-present Sound entity now; "needs loading" means
    // it has no backing connection resolved yet.
    let args = await this.castAwareLoadArgs(undefined, {
      useConnections: ['NativeAudio', 'Howler'],
      metadata: {},
      xhr: { headers: this.session?.authenticatedHeaders },
    });
    if (args) {
      try {
        await this.stereo.playTask.linked().perform(...args);
      } catch (e) {
        throw new Error('failed to load sound', { cause: e });
      }
    }

    if (this.loadedSound?.isResolved && !this.loadedSound.isPlaying) {
      await this.loadedSound.togglePause();
    }

    await timeout(200);
  });

  teardown() {
    if (this.settings?.debug) {
      console.log('destroyed fallback feed', this.url);
    }
  }
}
